import { AxiosError } from 'axios';

import { DISCOVERY_STAGE_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { ApiResponse } from '@/types/response.type';
import { Stage } from '@/types/stage.type';

export const getAllStages = async (): Promise<ApiResponse<Array<Stage>>> => {
  try {
    const response = await apiManager.get(DISCOVERY_STAGE_API_URL, {
      headers: { 'Content-Type': 'application/json' },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};
